import { useApiHook } from "@bjsdistribution/tms-component-library";
import { useEffect } from "react";

interface MaintenanceCount {
  type: string;
  id: number[];
  alias: string[];
  label: string;
  count: number;
  vehicle_ids: number[];
  audit_log_count: number;
}

export const useVehicleMaintenanceCounts = () => {
  const {
    data: breakdownData,
    loading: loadingBreakdown,
    fetchData: fetchBreakdown,
  } = useApiHook<MaintenanceCount[]>({
    endpoint: "vehicle_maintenance/count_vehicle_breakdown/",
    method: "GET",
  });

  const {
    data: defectsData,
    loading: loadingDefects,
    fetchData: fetchDefects,
  } = useApiHook<MaintenanceCount[]>({
    endpoint: "vehicle_maintenance/count_vehicle_defects/",
    method: "GET",
  });

  const {
    data: inspectionsData,
    loading: loadingInspections,
    fetchData: fetchInspections,
  } = useApiHook<MaintenanceCount[]>({
    endpoint: "vehicle_maintenance/count_vehicle_inspections/",
    method: "GET",
  });

  useEffect(() => {
    fetchBreakdown();
    fetchDefects();
    fetchInspections();
  }, []);

  return {
    breakdownData: breakdownData || [],
    defectsData: defectsData || [],
    inspectionsData: inspectionsData || [],
    loading: loadingBreakdown || loadingDefects || loadingInspections,
  };
};
